import * as React from "react";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { MenuItem } from "components/bootstrap";
import AddEvidenceModal from "security-app/components/Investigations/plugin/shared/AddEvidenceModal";
import { useInvestigationDrawer } from "security-app/components/Investigations/contexts/InvestigationDrawer";
import { useGetInvestigationDetails } from "security-app/hooks/useInvestigationsAPI";
import useActionCondition from "security-app/components/Investigations/plugin/useActionCondition";
import { bulkAddEvidence } from "security-app/hooks/api/investigationsAPI";
import useSelectedMessageEntities from "views/hooks/useSelectedMessageEntities";
const useUpdateInvestigation = () => {
  const { selectedEntities } = useSelectedMessageEntities();
  const queryClient = useQueryClient();
  return useCallback(
    (investigationIds) => bulkAddEvidence({
      payload: {
        investigation_ids: investigationIds,
        logs: selectedEntities.map(({ id, index }) => ({ id, index }))
      }
    }).then(async () => {
      await new Promise((resolve) => {
        setTimeout(() => {
          queryClient.invalidateQueries({ queryKey: ["get-investigation-details"] });
          resolve();
        }, 1e3);
      });
    }),
    [queryClient, selectedEntities]
  );
};
const MessageBulkActions = ({ modalRef }) => {
  const { selectedInvestigationId, setCollapsed } = useInvestigationDrawer();
  const { currentInvestigation } = useGetInvestigationDetails(selectedInvestigationId);
  const displayInvestigationActions = useActionCondition();
  const disabledAdd = !currentInvestigation || (currentInvestigation == null ? void 0 : currentInvestigation.archived);
  const updateInvestigation = useUpdateInvestigation();
  const onAddLog = async () => {
    if (disabledAdd) return;
    await updateInvestigation([selectedInvestigationId]);
    setCollapsed(false);
  };
  return displayInvestigationActions && /* @__PURE__ */ React.createElement(React.Fragment, null, disabledAdd || /* @__PURE__ */ React.createElement(MenuItem, { onClick: onAddLog, icon: "extension" }, "Add to investigation"), /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => {
    var _a;
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  }, icon: "extension" }, "Select an investigation"));
};
export const MessageBulkActionsModal = React.forwardRef((_, addEvidenceModalRef) => {
  const { selectedEntities } = useSelectedMessageEntities();
  const displayInvestigationActions = useActionCondition();
  const updateInvestigation = useUpdateInvestigation();
  const onAddEvidence = async (payload) => updateInvestigation(payload.investigation_ids);
  const ids = selectedEntities.map(({ id }) => id);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, displayInvestigationActions && /* @__PURE__ */ React.createElement(AddEvidenceModal, { index: void 0, ids, type: "logs", ref: addEvidenceModalRef, onSubmit: onAddEvidence }));
});
export default MessageBulkActions;
